module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAYCAYAAAB0kZQKAAABDklEQVRIS73WsQ3CMBCF4f8KJGagQKKipqZiBzp2gJIdoEIUbMAYdOwAEj1jHAoiyBDHOTtOUlv256fcS4QeH1U9AA8RObrHSl+GD2ANKLBxIb0gHEB55x9I5wgPoALpFBEAlJAbMOsMYQDcgYWIPDtBxACKSLIjYgFehKougYmI7GPHNwVQQXwAZ2AAbEVkZ4WkAn4Qf4DybBOkDeCLqAGYIG0Bb4SqDoFiXMaB6L2J5AC4SUyBCzCyQnIB/t8JMyQnwDcdFsgVmAcS+zahdbIqZaWqFkjd/tGA2sZMhCQBgrUdCUkGNH47jJBWgEZEsaAB0hpgQgQgWQBmhAeSDRCFcCAnYFX8EVl7oGndCw2ssB67gXYuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/checked-white.png
// module id = 1644
// module chunks = 0